module.exports = __webpack_public_path__ + "img/gys_19@2x.2a4b600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_19@2x.png
// module id = ZGlo
// module chunks = 0